import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { EventEmitter, hasValue, useT } from '@progress-fe/core';
import { Box, Button, Flex, Grid } from '@chakra-ui/react';
import { Input } from '../../inputs';
import { JsSelectNode, JsFieldInspector } from '../../jsFormBase';
import { useJsFieldFormData } from '../../../hooks';
import { JsFormConfigContext } from '../../../contexts';
/**
 * Component renders "/schemas/jsf-dynamic-connections" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is an instance of TJsDynamicConnectionsFormData.
 */
const DynamicConnectionsJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const { t } = useT();
    const { fieldConfig, fieldValues, onChangeFieldValues } = useJsFieldFormData({
        config: props.formData?.fieldConfig ?? null,
        values: props.formData?.fieldValues ?? null,
        watchPropsChanges: true,
        onChange: props.onChange
    });
    const handleChangeValue = (selectedOption, idx) => {
        if (fieldValues) {
            const fieldValuesCopy = structuredClone(fieldValues);
            fieldValuesCopy[idx].uuid = selectedOption.value;
            onChangeFieldValues(fieldValuesCopy);
        }
    };
    const handleChangeName = (name, idx) => {
        if (fieldValues) {
            const fieldValuesCopy = structuredClone(fieldValues);
            fieldValuesCopy[idx].name = name;
            onChangeFieldValues(fieldValuesCopy);
        }
    };
    const handleDeleteConnection = (idx) => {
        if (fieldValues) {
            const fieldValuesCopy = structuredClone(fieldValues);
            fieldValuesCopy.splice(idx, 1);
            onChangeFieldValues(fieldValuesCopy);
        }
    };
    const handleAddConnection = () => {
        if (fieldValues) {
            const fieldValuesCopy = structuredClone(fieldValues);
            fieldValuesCopy.push({ name: '', uuid: null });
            onChangeFieldValues(fieldValuesCopy);
        }
    };
    const handlePickElement = (elementId) => {
        EventEmitter.emit('PickItem', elementId);
    };
    const handleSelectElement = (elementId) => {
        EventEmitter.emit('SelectItem', elementId);
    };
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsx(Box, { "data-testid": "DynamicConnectionsJsField-test", "data-name": props.name, children: _jsx(Flex, { flexDirection: "column", gap: "4px", children: !fieldConfig || !fieldValues || fieldValues.length === 0 ? (_jsx(Box, { borderRadius: "4px", border: "1px solid", borderColor: "border", children: _jsx(Flex, { h: "64px", alignItems: "center", justifyContent: "center", children: t('connections.noConnections') }) })) : (_jsxs(Box, { p: "4px", borderRadius: "4px", border: "1px solid", borderColor: "border", children: [_jsx(Box, { mb: '4px', p: '3px 0 5px 0', borderBottom: '1px solid', borderColor: "border", children: props.schema.title }), _jsx(Flex, { flexDirection: 'column', gap: '4px', p: '0 0 2px 0', children: fieldValues?.map((item, index) => (_jsxs(Grid, { gridTemplateColumns: "minmax(0, 180px) 1fr", gap: "4px", children: [_jsx(Input, { size: "xs", variant: "outline", isOnChangeOnlyOnBlur: true, value: item.name, placeholder: t('common.name'), isInvalid: !hasValue(item.name), disabled: props.schema.readOnly || fieldConfig.isFlowNameReadonly, rightElement: props.schema.$comment ? _jsx(_Fragment, { children: props.schema.$comment }) : undefined, onChange: (value) => handleChangeName(value, index) }), _jsx(Flex, { flexDirection: "column", gap: "4px", children: _jsx(JsSelectNode, { name: `${Date.now()}`, options: fieldConfig.options, selected: fieldConfig.options.find((o) => o.value === item.uuid), isDisabled: props.schema.readOnly, isDeleteDisabled: !fieldConfig.isFlowDeletable, onChange: (selected) => handleChangeValue(selected, index), onDelete: () => handleDeleteConnection(index), onSelect: handleSelectElement, onPick: handlePickElement }) })] }, index))) }), !props.schema.readOnly && fieldValues.length < fieldConfig.capacitance && (_jsx(Box, { p: '3px 0 2px 0', children: _jsx(Button, { width: "100%", size: "smSquare", variant: "ghost", onClick: handleAddConnection, children: t('actions.addFlow') }) }))] })) }) }) }));
};
export const DynamicConnectionsJsField = DynamicConnectionsJsFieldFC;
//# sourceMappingURL=DynamicConnectionsJsField.js.map